export default "__VITE_ASSET__BZEIPah___"